import { ref, readonly } from 'vue'

export const useHoldAsNeeded = (initial) => {
  const state = ref(structuredClone(initial))

  const set = (value) => {
    state.value = value
  }

  const reset = () => {
    state.value = structuredClone(initial)
  }

  const clear = () => {
    state.value = ''
  }

  return { holdAsNeeded: readonly(state), set, reset, clear }
}